"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var P = _interopRequireDefault(require("make-plural/plurals.js"));

var C = _interopRequireDefault(require("make-plural/pluralCategories.js"));

var _factory = _interopRequireDefault(require("./factory"));

var _pseudoNumberFormat = _interopRequireDefault(require("./pseudo-number-format"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// In a .mjs context, CommonJS imports only expose the default endpoint. We're
// using them here because with this many small functions, Webpack produces less
// cruft than for ES module exports.
var Plurals = P.default || P;
var Categories = C.default || C;
/* istanbul ignore next */

var NumberFormat = (typeof Intl === "undefined" ? "undefined" : _typeof(Intl)) === 'object' && Intl.NumberFormat || _pseudoNumberFormat.default; // make-plural exports are cast with safe-identifier to be valid JS identifiers

var id = function id(lc) {
  return lc === 'in' ? '_in' : lc === 'pt-PT' ? 'pt_PT' : lc;
};

var getSelector = function getSelector(lc) {
  return Plurals[id(lc)];
};

var getCategories = function getCategories(lc, ord) {
  return Categories[id(lc)][ord ? 'ordinal' : 'cardinal'];
};

var PluralRules = (0, _factory.default)(NumberFormat, getSelector, getCategories);
var _default = PluralRules;
exports.default = _default;